/** Mobile-first list primitives: cards on phones, tables stay for md+ screens. */
export const MobileCards = ({ children, testid }) => (
  <div className="space-y-3 md:hidden" data-testid={testid}>{children}</div>
);

export const EmptyCard = ({ children }) => (
  <div className="rounded-xl border border-dashed border-border p-6 text-center text-sm text-muted-foreground">
    {children}
  </div>
);

export const DataCard = ({ leading, title, subtitle, badge, rows = [], actions, testid }) => {
  const cells = rows.filter(Boolean);
  return (
    <div className="rounded-xl border border-border bg-card p-4" data-testid={testid}>
      <div className="flex items-start justify-between gap-3">
        <div className="flex min-w-0 items-center gap-2.5">
          {leading}
          <div className="min-w-0">
            <div className="truncate font-medium leading-tight">{title}</div>
            {subtitle && <div className="mt-0.5 truncate text-xs text-muted-foreground">{subtitle}</div>}
          </div>
        </div>
        {badge && <div className="shrink-0">{badge}</div>}
      </div>
      {cells.length > 0 && (
        <dl className="mt-3 grid grid-cols-2 gap-x-3 gap-y-2">
          {cells.map((r, i) => (
            <div key={i} className={`min-w-0 ${r.full ? "col-span-2" : ""}`}>
              <dt className="text-[10px] font-semibold uppercase tracking-wider text-muted-foreground">{r.label}</dt>
              <dd className={`text-sm ${r.wrap ? "break-words" : "truncate"}`}>{r.value}</dd>
            </div>
          ))}
        </dl>
      )}
      {actions && (
        <div className="mt-3 flex flex-wrap items-center gap-2 border-t border-border pt-3">{actions}</div>
      )}
    </div>
  );
};
